import { render, staticRenderFns } from "./ItemConfig.vue?vue&type=template&id=7d1924ed&scoped=true"
import script from "./ItemConfig.vue?vue&type=script&lang=js"
export * from "./ItemConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1924ed",
  null
  
)

export default component.exports